// Standalone application boot.
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './experience/red-thread.css';
import './experience/mobile-app.css';
import { applyTheme, readTheme } from './experience/theme';

applyTheme(/^\/moderation\/?$/.test(window.location.pathname) ? 'light' : readTheme());

const ModerationApp = lazy(() => import('./ModerationApp').then((module) => ({ default: module.ModerationApp })));

const el = document.getElementById('root');
if (el) {
  const appPath = window.location.pathname === '/' || /^\/north-bank(?:\/|$)/.test(window.location.pathname);
  const ownerPath = /^\/moderation\/?$/.test(window.location.pathname);
  createRoot(el).render(
    <StrictMode>
      {ownerPath
        ? <Suspense fallback={<main className="moderation-login"><p className="moderation-status">Opening the private owner space…</p></main>}><ModerationApp /></Suspense>
        : appPath ? <App /> : <main className="screen"><h1>This page needs a connection</h1><p>Reconnect and reload to read this page, or return to the matchday app.</p><a href="/">Open matchday</a></main>}
    </StrictMode>,
  );
}

if (!import.meta.env.DEV && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/app-sw.js', { updateViaCache: 'none' }).catch(() => undefined);
  });
}
